import { Dialog } from "@mui/material";
import classNames from "classnames";
import { FC } from "react";

import CustomButton from "../Button/Button";
import "./PopupDialog.scss";

interface IButtonAction {
	text: string;
	onClick: () => void;
	className?: string;
}

interface IPopupDialogProps {
	"data-testid": string;
	open: boolean;
	title?: string;
	content: JSX.Element;
	onClose?: () => void;
	buttons?: Array<IButtonAction>;
	className?: string;
}

const PopupDialog: FC<IPopupDialogProps> = (props) => {
	return (
		<Dialog open={props.open} onClose={props.onClose} data-testid={props["data-testid"]}>
			<div className={classNames("PopupDialogContainer", props.className)}>
				{props.title && <div className="PopupDialogTitle">{props.title}</div>}
				<div className="PopupDialogContent">{props.content}</div>
				{props.buttons && (
					<div className="PopupDialogActions">
						{props.buttons?.map((btn) => (
							<CustomButton onClick={btn.onClick} className={btn.className} key={btn.text}>
								{btn.text}
							</CustomButton>
						))}
					</div>
				)}
			</div>
		</Dialog>
	);
};

export default PopupDialog;
